export const primaryColor = 'black';
export const rimColor = '#F8B800';
export const contrastColor = 'white';
export const fontFamily = 'Helvetica';
export const shadowColor = '#00000040';

export const segmentsColors = [
	'#7269E0',
	'#FEBD01',
	'#D6783C',
];
